/**
 * Pure-data English catalogue for namespace 'time' (W1-01 core-time-math): beat-field parse errors produced by
 * core/time/beatSyntax.ts `parseBeat` and the bar/beat label of `barBeatRef`. Imports only core/util/types.
 */

import type { MessageCatalog } from '../util/types';

const catalog: MessageCatalog = {
  ns: 'time',
  locale: 'en',
  messages: {
    'parse.empty': 'Type a beat, for example 12:3/4',
    'parse.incomplete': 'Something is missing at the end, for example 12:3/4',
    'parse.unexpected': 'Unexpected "{char}" at character {pos}',
    'parse.expectedNumber': 'Expected a number at character {pos}',
    'parse.expectedFraction': 'Expected a fraction such as 3/4 at character {pos}',
    'parse.zeroDenominator': 'The bottom of a fraction cannot be 0',
    'parse.decimalInFraction': 'Fractions take whole numbers: write 3/4, not 1.5/2',
    'parse.tooLarge': 'This beat is out of range',
    'parse.tooPrecise': 'Too precise: use a simpler fraction or fewer decimals',
    'parse.needsSnap': 'Steps such as 12;1 need a beat snap; choose a snap first',
    'parse.needsSnapDecimal': 'In RPE style, 12.1 means beat 12 plus one snap step; choose a beat snap first',
    'parse.needsTempo': 'Seconds cannot be used here; type a beat such as 12:3/4',
    'parse.badTime': 'This time is outside the tempo map',
    'parse.mixedUnits': 'Seconds and beats cannot be combined; use one or the other',
    'parse.clockRange': 'Minutes and seconds must be below 60 here (character {pos})',
    'parse.atFirst': 'Put "@" at the start, as in @37:1/4 or @1:23.5',
    'parse.noMarkers': 'Markers cannot be used here',
    'parse.unknownMarker': 'No marker named "{name}"',
    'parse.markerName': 'Type a marker name after "{prefix}"',
    'parse.markerFirst': 'Put the marker first, as in m12+2',
    'parse.unclosedQuote': 'Close the marker name with a quote (")',
    barBeat: 'bar {bar} . beat {beat}{frac}',
  },
};

export default catalog;
